module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/bath-3171a1eff8034a586f284068645a92df.webp";